/* Black Friday page countdown: 12 hours per visitor. The end time is saved on the first visit, so a reload does not reset it. */
(function () {
  var KEY = 'poc_bf_sale_end_v1';
  var LEN = 12 * 60 * 60 * 1000;
  var endAt = 0;
  function getEnd() {
    if (endAt) return endAt;
    var now = Date.now();
    var saved = 0;
    try {
      saved = parseInt(window.localStorage.getItem(KEY), 10);
      if (!(saved > 0) || saved > now + LEN + 60000) saved = 0;
    } catch (e) { saved = 0; }
    if (!saved) {
      saved = now + LEN;
      try { window.localStorage.setItem(KEY, String(saved)); } catch (e) {}
    }
    endAt = saved;
    return endAt;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = getEnd() - Date.now();
    var boxes = document.querySelectorAll('[data-bf-count]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var live = box.querySelector('[data-bf-live]');
      var done = box.querySelector('[data-bf-done]');
      if (left <= 0) {
        if (live) live.hidden = true;
        if (done) done.hidden = false;
        continue;
      }
      var s = Math.floor(left / 1000);
      var vals = { h: pad(Math.floor(s / 3600)), m: pad(Math.floor((s % 3600) / 60)), s: pad(s % 60) };
      for (var k in vals) {
        var el = box.querySelector('[data-bf="' + k + '"]');
        if (el && el.textContent !== vals[k]) el.textContent = vals[k];
      }
      if (live) live.hidden = false;
      if (done) done.hidden = true;
    }
    return left > 0;
  }
  function start() {
    if (!document.querySelector('[data-bf-count]')) return;
    var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
